// extracted by mini-css-extract-plugin
module.exports = {"notFound404":"NotFoundPage_notFound404__2Vboi","image404":"NotFoundPage_image404__1D5CY"};